export class EnvError extends Error {
    public constructor(message?: string) {
        super(message);
    }
}
